module.exports = __webpack_public_path__ + "media/img/illustrations/icons/bot-face-locked-09fa192b4e6b055ef2774abf28867be2.svg";